module.exports = __webpack_public_path__ + "static/03-2e97c805b71d0f14c394f514f9c13de6.jpg";